module.exports = __webpack_public_path__ + "img/qr-apk-th-en-page.16de8246.png";